import { media, styled, typography } from '@pulse-web-ui/theme';

export const AppFooter = styled.footer`
  ${typography.regular12}
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  background: ${({ theme }) => theme.colors.neutral[10]};
  color: ${({ theme }) => theme.colors.text.secondary};
  letter-spacing: 0.1px;
  box-sizing: border-box;

  ${media.desktop} {
    padding: 24px 0;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  padding: 24px 0 0;
  margin-top: auto;
`;

export const AgreementLink = styled.a`
  color: ${({ theme }) => theme.colors.text.primary};
`;
